exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-label-desc {\n  font-size:0.4375rem;\n  color:#666;\n}\n", ""]);

// exports
